import ReactDOM from 'react-dom/client'
import Rag from './src/Rag'


const root= ReactDOM.createRoot(document.getElementById("root"))

const App=()=>{
    return <div>
      <Rag/>
    </div>
}
root.render(<App/>)